import React from 'react';

export type SubmitFormHandleType = (e: React.FormEvent<HTMLFormElement>) => void;

interface IFormProps {
  children?: React.ReactNode;
  handleSubmitForm?: SubmitFormHandleType;
}

// interface IValues {
//   /* Key value pairs for all the field values with key being the field name */
//   [key: string]: any;
// }

// interface IErrors {
//   /* The validation error messages for each field (key is the field name */
//   [key: string]: string;
// }

// interface IFormState {
//   /* The field values */
//   values: IValues;

//   /* The field validation error messages */
//   errors: IErrors;

//   /* Whether the form has been successfully submitted */
//   submitSuccess?: boolean;
// }

export function Form({ children, handleSubmitForm }: IFormProps) {
  return (
    <form onSubmit={handleSubmitForm}>
      { children }
    </form>
  );
}

